/**
 * Pollo Seedance 1.5 Pro：input 结构单独封装
 */
import { isUrl } from './utils'

export function buildBody(params) {
  var prompt = (params.prompt || '').trim()
  if (!prompt) throw new Error('视频提示（prompt）必填')
  var input = {
    prompt: prompt,
    resolution: params.videoRes || params.resolution || '480p',
    length: Math.min(12, Math.max(4, parseInt(params.videoDuration || params.length || 5, 10) || 5)),
    aspectRatio: params.aspectRatio || '16:9',
    cameraFixed: params.cameraFixed === true,
    generateAudio: params.generateAudio === true
  }
  var seed = params.seed != null && params.seed !== '' && params.seed !== -1 ? parseInt(params.seed, 10) : null
  if (seed != null && !isNaN(seed) && seed <= 2147483647) input.seed = seed
  if (isUrl(params.referenceImage)) input.image = params.referenceImage.trim()
  if (isUrl(params.imageTail || params.endFrameImage)) input.imageTail = (params.imageTail || params.endFrameImage).trim()
  var body = { input: input }
  if (params.webhookUrl && isUrl(params.webhookUrl)) body.webhookUrl = params.webhookUrl
  return body
}
